import { BLACKLIST_APPLY_TYPE } from "@/constants";
import { useModal } from "@/hooks/modals/useModal";
import { useBlacklistRecordDetail } from "./useBlacklistRecordDetail";

export function useFormEditable() {
  const { props } = useModal("SUPPLIER_BLACK_LIST");
  const { flowStatus, mode, isReadOnly } = props;

  const detail = useBlacklistRecordDetail(props.recordId);

  const isInReviewMode = mode === "inReview";

  // mode 为 inReview 表单不可编辑
  if (isInReviewMode || isReadOnly) {
    return {
      isAddToEditable: false,
      isRemoveFromEditable: false,
    };
  }

  if (!detail) {
    return {
      isAddToEditable: true,
      isRemoveFromEditable: false,
    };
  }

  return {
    isAddToEditable:
      detail.applyType === BLACKLIST_APPLY_TYPE.ADD_TO &&
      flowStatus === "已驳回",
    isRemoveFromEditable:
      (detail.applyType === BLACKLIST_APPLY_TYPE.ADD_TO &&
        flowStatus === "已通过") ||
      (detail.applyType === BLACKLIST_APPLY_TYPE.REMOVE_FROM &&
        flowStatus === "已驳回"),
  };
}
